import React from "react";
import { INVESTORS, INVESTOR_HOT_LIST } from "../../consts/tables";
import { INVESTOR_HOT_LIST_CHECK, INVESTOR_HOT_LIST_CHECK_DELETED } from "../../consts/queries";
import InvestorInfo from "./InvestorInfo";
import CRUD from "../CRUD/CRUD";
import { getCurrentAccess } from "../../access";
import { editsEverySummitRecord } from "../../access-levels";
import { browserHistory } from "react-router";
import { getData, manageData } from "../../requests/CRUD";
import { executeBackendQuery } from "../../requests/executeBackendQuery";
import { notesApi } from "../../requests/api";
import NotesWindow from "../NotesWindow";
import { getOpenInCrmHref } from "../OpenInCrmButton/OpenInCrmButton";
import { isDeceased } from "../DeceasedPill/DeceasedPill";
import { updateInvestor } from "../../requests/investors";
import { isOn } from "../../utils";

export default class CRUDInvestor extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			data: null,
			original: null,
			isBusy: null,
			error: null,
			success: null,
			errorTabs: [],
			currentTab: 0,
			viewMode: this.props.edit || false,
			newFirm: false,
			isHotList: false,
			hotListRowId: null,
			isHotListBusy: false,
			notes: null,
			notesError: null,
			notesOpen: false,
			secondContact: null,
		};
		// Lists the notes window has published, so an older Kore answer can't replace them.
		this.notesChanges = 0;

		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChangeInput = this.handleChangeInput.bind(this);
		this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
		this.saveData = this.saveData.bind(this);
		this.handleDeceasedChange = this.handleDeceasedChange.bind(this);
		this.handleActiveBuyerChange = this.handleActiveBuyerChange.bind(this);
		this.handleSecondContactChange = this.handleSecondContactChange.bind(this);
		this.handleHotListToggle = this.handleHotListToggle.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.params.id !== nextProps.params.id) {
			this.fetch(nextProps.params.id);
		}
	}

	componentDidMount() {
		this.fetch(this.props.params.id);
	}

	fetch(id) {
		this.setState({
			data: null,
			error: null,
			success: null,
			isHotList: false,
			hotListRowId: null,
			notes: null,
			notesError: null,
			notesOpen: false,
			secondContact: null,
		});

		if (id === undefined) {
			this.setState({ data: {} });
			return;
		}

		getData({
			tableCode: INVESTORS,
			options: {
				filter: [{ text: id, code: "ARCIMEDES_ROW_ID", type: "exact" }],
			},
		}).then((res) => {
			if (res && res.success && Array.isArray(res.data) && res.data.length) {
				const row = res.data[0];
				const deleted = row.DELETED;
				if (deleted === '1' || deleted === 1 || (deleted != null && deleted !== '' && deleted !== '0')) {
					this.setState({
						data: false,
						error: 'Investor not found',
					});
					return;
				}
				this.setState({
					data: row,
					original: { ...row },
					error: null,
				}, () => {
					this.fetchHotListStatus(id);
					this.fetchNotes(id);
					this.fetchSecondContact(row.SECOND_CONTACT_ID);
				});
			} else {
				this.setState({
					data: false,
					error: res.message ? res.message : "Unidentified Error",
				});
			}
		});
	}

	fetchSecondContact(id) {
		if (!id) return;

		getData({
			tableCode: INVESTORS,
			options: {
				filter: [{ text: id, code: "ARCIMEDES_ROW_ID", type: "exact" }],
			},
		}).then((res) => {
			// A 2nd Contact deleted since has no row to show, and a late answer for the previous investor is not this one's.
			if (res && res.success && Array.isArray(res.data) && res.data.length
				&& this.state.data && String(this.state.data.SECOND_CONTACT_ID) === String(id)) {
				this.setState({ secondContact: res.data[0] });
			}
		});
	}

	fetchNotes(investorId) {
		const owner = { type: 'investor', id: String(investorId) };

		notesApi
			.list(owner)
			.then((notes) => {
				this.setState({ notes, notesError: null });

				// Kore's own notes come in after iCLIMB's copy is showing; a save in the window since then is newer.
				const changes = this.notesChanges;

				return notesApi
					.refresh(owner)
					.then((fresh) => this.notesChanges === changes && this.setState({ notes: fresh }))
					.catch((error) => this.setState({
						notesError: error.status ? error.message : 'Couldn’t check Kore for newer notes. Check your connection.',
					}));
			})
			.catch((error) => this.setState({ notes: null, notesError: 'Couldn’t load the notes: ' + error.message }));
	}

	fetchHotListStatus(investorId) {
		const userEmail = this.props.userData && this.props.userData.email;
		if (!investorId || !userEmail) return;

		executeBackendQuery({
			queryName: INVESTOR_HOT_LIST_CHECK,
			options: { param: { INVESTOR_ID: String(investorId), USER_EMAIL: userEmail } },
		}).then((res) => {
			const row = res && res.success && Array.isArray(res.data) && res.data[0];
			this.setState({
				isHotList: Boolean(row),
				hotListRowId: row ? row.ARCIMEDES_ROW_ID : null,
			});
		}).catch(() => {
			// non-fatal; hot list checkbox simply stays unchecked
		});
	}

	/**
	 * Push the hot list change to the CRM.
	 *
	 * `fetch` only rejects on network failure, so the response has to be checked
	 * by hand — otherwise a refusal (most often: this user has no CRM API token)
	 * is discarded and the toggle looks like it worked while the CRM never
	 * changed. The local hot list row has already been written by this point, so
	 * the error says the CRM specifically is out of step rather than claiming
	 * nothing happened.
	 */
	async syncHotListToCrm(investorId, userEmail, action) {
		let res;
		try {
			res = await fetch('/api/crm/investor-hotlist', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ investorId, userEmail, action }),
			});
		} catch (err) {
			this.setState({ error: 'Could not reach the server to update the Hot List in the CRM. Please try again.' });
			return;
		}

		if (res.ok) return;

		let message = null;
		try {
			const body = await res.json();
			message = body && body.message;
		} catch (err) {
			// Fall through to the generic message below.
		}

		this.setState({
			error: message || `The Hot List could not be updated in the CRM (error ${res.status}).`,
		});
	}

	async handleHotListToggle(newIsHotList) {
		if (this.state.isHotListBusy) return;

		const investorId = this.state.data && this.state.data.ARCIMEDES_ROW_ID;
		const userEmail = this.props.userData && this.props.userData.email;
		if (!investorId || !userEmail) return;

		this.setState({ isHotList: newIsHotList, isHotListBusy: true });

		try {
			if (newIsHotList) {
				const deletedRowCheck = await executeBackendQuery({
					queryName: INVESTOR_HOT_LIST_CHECK_DELETED,
					options: { param: { INVESTOR_ID: String(investorId), USER_EMAIL: userEmail } },
				});

				const deletedRow = deletedRowCheck && deletedRowCheck.success && Array.isArray(deletedRowCheck.data) && deletedRowCheck.data[0];

				let rowId = null;
				if (deletedRow) {
					await manageData({
						tableCode: INVESTOR_HOT_LIST,
						data: [{ ARCIMEDES_ROW_ID: deletedRow.ARCIMEDES_ROW_ID, DELETED: 0 }],
					});
					rowId = deletedRow.ARCIMEDES_ROW_ID;
				} else {
					const createRes = await manageData({
						tableCode: INVESTOR_HOT_LIST,
						data: [{ INVESTOR_ID: investorId, TEAM_MEMBER_EMAIL: userEmail }],
					});
					const newRow = createRes && createRes.success && Array.isArray(createRes.data) && createRes.data[0];
					rowId = newRow ? newRow.ARCIMEDES_ROW_ID : null;
				}

				this.setState({ hotListRowId: rowId, isHotListBusy: false });

				await this.syncHotListToCrm(investorId, userEmail, 'add');
			} else {
				const hotListRowId = this.state.hotListRowId;
				if (!hotListRowId) {
					this.setState({ isHotList: false, isHotListBusy: false });
					return;
				}

				await manageData({
					tableCode: INVESTOR_HOT_LIST,
					data: [{ ARCIMEDES_ROW_ID: hotListRowId, DELETED: 1 }],
				});

				this.setState({ hotListRowId: null, isHotListBusy: false });

				await this.syncHotListToCrm(investorId, userEmail, 'remove');
			}
		} catch (err) {
			console.error('[investor-hotlist] Operation failed', err);
			this.setState({ 
				isHotList: !newIsHotList, 
				isHotListBusy: false 
			});
		}
	}

	handleSubmit(e) {
		e.preventDefault();

		if (this.state.viewMode) this.setState({ viewMode: false });

		if (
			this.state.isBusy ||
			!this.state.data.NAME ||
			this.state.viewMode === true
		) return;

		this.setState({ viewMode: true }, () => this.saveData());
	}

	handleChangeInput(key, value) {
		this.setState({
			data: Object.assign(this.state.data, { [key]: value }),
		});
	}

	handleChangeDropdown(query, queryType, x, key) {
		const data = { ...this.state.data };
		data[key] = query[key];
		this.setState({ data });
	}

	handleDeceasedChange(checked) {
		this.setState({ data: { ...this.state.data, DECEASED: checked } });
	}

	handleActiveBuyerChange(checked) {
		this.setState({ data: { ...this.state.data, ACTIVE_BUYER: checked } });
	}

	handleSecondContactChange(picked, queryType, id, key, typeKey, option) {
		this.setState({
			data: { ...this.state.data, SECOND_CONTACT_ID: picked[key] || null },
			secondContact: option || null,
		});
	}

	saveData() {
		if (this.state.isBusy) return;

		this.setState({ isBusy: true, error: null, success: null });

		const { data } = this.state;
		// Delete and Undelete, and a new investor, stay on the table save; an edit goes through the investor's own route, which tells its Kore lead too.
		const isEdit = Boolean(data.ARCIMEDES_ROW_ID) && (data.DELETED || null) === ((this.state.original || {}).DELETED || null);
		const save = isEdit
			? updateInvestor(data.ARCIMEDES_ROW_ID, { ...data, DECEASED: isDeceased(data), ACTIVE_BUYER: isOn(data.ACTIVE_BUYER), SECOND_CONTACT_ID: data.SECOND_CONTACT_ID || null })
				.then((saved) => ({ success: true, data: [saved] }))
			: manageData({ tableCode: INVESTORS, data: [data] });

		return save.then((res) => {
			if (res && res.success) {
				// What a delete left in the row is what the next save is compared with: Undelete must not read as an edit.
				this.setState({ isBusy: false, success: "Saved", ...(isEdit ? {} : { original: res.data[0] }) }, () => {
					if (!this.props.edit) {
						browserHistory.push({
							pathname: `${arc.path.base}investor/${res.data[0].ARCIMEDES_ROW_ID}`,
						});
					}
				});
				window.scrollTo(0, 0);
			} else {
				this.setState({
					isBusy: null,
					error: res && res.message ? res.message : "Unspecified error",
				});
			}
		}).catch((error) => {
			this.setState({ isBusy: null, error: error.message });
		});
	}

	render() {
		const data = this.state.data;
		const { edit } = this.props;

		if (!data) {
			return <div className='Page'><div className='container'><div className='loader'/></div></div>;
		}

		const investorName = data.NAME || 'New Investor';
		const investorId = data.ARCIMEDES_ROW_ID ? String(data.ARCIMEDES_ROW_ID) : null;

		return (
			<React.Fragment>
			<CRUD
				tabsData={[
					{
						name: "INVESTOR",
						renderedComponent: (
						<InvestorInfo
							data={data}
							handleChangeInput={this.handleChangeInput}
							handleChangeDropdown={this.handleChangeDropdown}
							viewMode={this.state.viewMode}
							deleted={data && data.DELETED === "1"}
							addNewItem={() => {}}
							newFirm={this.state.newFirm}
							isHotList={this.state.isHotList}
							isHotListBusy={this.state.isHotListBusy}
							onHotListToggle={this.handleHotListToggle}
							notes={this.state.notes}
							notesError={this.state.notesError}
							onShowNotes={investorId ? () => this.setState({ notesOpen: true }) : null}
							secondContact={this.state.secondContact}
							onDeceasedChange={this.handleDeceasedChange}
							onActiveBuyerChange={this.handleActiveBuyerChange}
							onSecondContactChange={this.handleSecondContactChange}
						/>
						),
					},
				]}
				backLink={`${arc.path.base}investors`}
				edit={edit}
				state={this.state}
				setState={this.setState.bind(this)}
				handleSubmit={this.handleSubmit}
				saveData={this.saveData}
				type="investor"
				backName="INVESTORS"
				title={investorName}
				/* Edit and Delete for whoever edits every SUMMIT record (the old admin rule). */
				forceActions={editsEverySummitRecord(getCurrentAccess())}
			/>
			{this.state.notesOpen && investorId && (
				<NotesWindow
					owner={{ type: 'investor', id: investorId }}
					title={investorName}
					subtitle="Investor notes"
					links={data.LEAD_ID ? [{ label: 'Kore', href: getOpenInCrmHref(data.LEAD_ID, 'lead'), title: 'Open the lead in Kore' }] : []}
					theme="light"
					deletePrompt="Delete? It’s removed from Kore too."
					onClose={() => this.setState({ notesOpen: false })}
					onChange={(notes) => {
						this.notesChanges += 1;
						this.setState({ notes, notesError: null });
					}}
				/>
			)}
			</React.Fragment>
		);
	}
}
